export default {
  en: {
    specialOffer: 'Special Offer',
    newSpecialOffer: 'New Special Offer',
    draft: 'Draft',
    published: 'Published',
    agentName: 'Agent Name',
    issueDate: 'Issue Date',
    lastUpdate: 'Last Update',
    hotel: 'Hotel',
    promotion: 'Promotion',
    specialOfferValid: 'Special Offer Valid',
    salesPerson: 'Sales Person',
    totalAgents: 'Total Agents',
    agents: 'Agents',
    internalNote: 'Internal Note',
    edit: 'Edit',
    preview: 'Preview',
    downloadAll: 'Download All',
    duplicate: 'Duplicate',
    delete: 'Delete',
    confirmDeleteSpecialOfferMessage: 'Confirm to delete <strong>{refCode}</strong> ?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    updateSpecialOfferStatusSuccess: 'Update Status Success',
    sendEmailSpecialOffers: 'Send Email Special Offers',
    signedDocument: 'Signed Document'
  },
  th: {
    specialOffer: 'ข้อเสนอพิเศษ',
    newSpecialOffer: 'ข้อเสนอพิเศษใหม่',
    draft: 'ฉบับร่าง',
    published: 'เผยแพร่',
    agentName: 'ชื่อตัวแทน',
    issueDate: 'วันที่ออก',
    lastUpdate: 'วันที่แก้ไขล่าสุด',
    hotel: 'โรงแรม',
    promotion: 'โปรโมชั่น',
    specialOfferValid: 'ระยะเวลา',
    salesPerson: 'พนักงานขาย',
    totalAgents: 'จำนวนตัวแทน',
    agents: 'ตัวแทน',
    internalNote: 'หมายเหตุ',
    edit: 'แก้ไข',
    preview: 'ดูตัวอย่าง',
    downloadAll: 'ดาวน์โหลดทั้งหมด',
    duplicate: 'คัดลอก',
    delete: 'ลบ',
    confirmDeleteSpecialOfferMessage: 'กรุณายืนยันการลบ <strong>{refCode}</strong> ?',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    updateSpecialOfferStatusSuccess: 'เปลี่ยนสถานะสำเร็จ',
    sendEmailSpecialOffers: 'ส่งอีเมลสำหรับข้อเสนอพิเศษ',
    signedDocument: 'เอกสารลงนาม'
  }
}
